(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["g20-product-nav"]) return;
  try {
    
  const navigation = document.querySelector('.g20-product-nav');
  if (navigation) {
    const targets = [
      ['g20-overview', '[id$="__main"]'],
      ['g20-performance', '[id$="__g20_feature_story"]'],
      ['g20-specs', '[id$="__g20_specs_faq"]'],
      ['g20-faqs', '#g20-faq-list'],
      ['g20-reviews', '[id$="__1786705022ca7c47d3"]']
    ];
    const links = Array.from(navigation.querySelectorAll('.g20-product-nav__link'));
    const observed = [];

    targets.forEach(([id, selector]) => {
      const target = document.querySelector(selector);
      if (target) {
        target.id = id;
        observed.push(target);
      }
    });

    const setActive = (id) => {
      links.forEach((link) => {
        const active = link.getAttribute('href') === `#${id}`;
        link.classList.toggle('is-active', active);
        if (active) {
          link.setAttribute('aria-current', 'location');
        } else {
          link.removeAttribute('aria-current');
        }
      });
    };

    links.forEach((link) => {
      link.addEventListener('click', () => setActive(link.hash.slice(1)));
    });

    const observer = new IntersectionObserver((entries) => {
      const visible = entries
        .filter((entry) => entry.isIntersecting)
        .sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];
      if (visible) setActive(visible.target.id);
    }, { rootMargin: '-20% 0px -65% 0px', threshold: [0, 0.1, 0.35] });

    observed.forEach((target) => observer.observe(target));
  }

  } catch(e) { console.error(e); }
})();
})();
